import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export function LegalDoc({ title, updated, sections }) {
  const { t } = useLang();
  return (
    <div className="min-h-screen bg-[#0A0C10] text-slate-200">
      <header className="border-b border-slate-800 px-4 py-4 sm:px-8">
        <div className="mx-auto flex max-w-3xl items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="legal-home-link">
            <img src="/logo.png" alt="Golden Terminal" className="h-8 w-8 object-contain" />
            <div>
              <div className="font-heading text-sm font-bold leading-none text-white">GOLDEN</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-amber-500/80">Terminal</div>
            </div>
          </Link>
          <Link to="/" className="flex items-center gap-1.5 text-sm text-slate-400 hover:text-white">
            <ArrowLeft className="h-4 w-4" /> {t("legal.home")}
          </Link>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-4 py-10 sm:px-8" data-testid="legal-page">
        <h1 className="font-heading text-3xl font-bold text-white sm:text-4xl">{title}</h1>
        <p className="mt-2 text-sm text-slate-500">{t("legal.updated")} {updated}</p>
        <div className="mt-8 space-y-8">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-heading text-lg font-semibold text-amber-400">{s.h}</h2>
              <div className="mt-2 space-y-2 text-sm leading-relaxed text-slate-300">
                {s.p.map((para, j) => <p key={j}>{para}</p>)}
              </div>
            </section>
          ))}
        </div>
        <p className="mt-12 text-xs text-slate-600">{t("legal.contact")}</p>
      </main>
    </div>
  );
}
